import React from "react";
import { useLang } from "@/context/LanguageContext";

export const SectionHeader = ({ titleKey, subtitleKey, action }) => {
  const { t } = useLang();
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        <div className="mb-2 h-1 w-12 rounded-full bg-gmoaa-saffron" />
        <h2 className="font-serif text-2xl font-semibold text-gmoaa-green sm:text-3xl">{t(titleKey)}</h2>
        {subtitleKey && <p className="mt-1 text-sm text-gmoaa-text-muted sm:text-base">{t(subtitleKey)}</p>}
      </div>
      {action}
    </div>
  );
};
